@use "../../styles/breakpoint.module.scss" as *;

$header-height: 80;

:export {
    headerHeight: $header-height;
}

:root {
    --header-height: var(--spacer-#{$header-height});
}

.nav {
    position: sticky;
    top: 0;
    height: var(--header-height);
    transition: translate 0.3s ease-in-out;
    z-index: 100;

    &.navOpen {
        z-index: 101;
    }

    &.hidden {
        translate: 0 -100%;
    }
}

.logo {
    --padding: 32px;

    @media ($below-desktop) {
        --padding: 24px;
    }

    @media ($below-mobile) {
        --padding: 8px;
    }

    max-width: var(--spacer-200);
    fill: var(--beige);
    position: fixed;
    left: max(var(--padding), env(safe-area-inset-left));
    top: 0;
    z-index: 110;

    // This helps with the JS that switches between desktop and mobile mode
    margin-right: var(--padding);

    svg {
        width: 100%;
        height: 100%;
    }
}

.logoText {
    fill: currentColor;
}

.themeWrapperBase {
    --l1-padding-block: 16px;

    visibility: inherit;
}

.themeWrapper {
    composes: themeWrapperBase;
}

.themeWrapperMobile {
    composes: themeWrapperBase;
    position: absolute;
    inset: var(--header-height) 0 auto;
    max-height: 100vh;
    max-height: calc(100dvh - var(--header-height));
    padding-block: calc(var(--header-height) - var(--l1-padding-block))
        var(--spacer-40);
    padding-inline: max(var(--spacer-48), env(safe-area-inset-left));
    border-top: 1px solid var(--pale-navy);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @media ($below-mobile) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100vh;
        height: calc(100dvh - var(--header-height));
    }
}

.l1NavBase {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
}

.l1Nav {
    composes: l1NavBase;
    composes: container from "../../styles/composable/layout.module.css";
    justify-content: flex-end;
    margin-right: calc(var(--labui-container-margin) - var(--spacer-12));
}

.l1NavMobile {
    composes: l1NavBase;
    flex-direction: column;
    padding-bottom: var(--spacer-16);
}

.hideNav {
    // must be this instead of display: none to make collision detection with
    // the logo work as expected
    visibility: hidden;
    pointer-events: none;
}

.socials {
    .hideNav &,
    .themeWrapper & {
        display: none;
    }
}

.mobileMenuControl {
    display: inline-flex;
    align-items: center;
    height: var(--header-height);
}

.hideMobileMenuControl {
    display: none;
}

.mobileMenuClickable {
    position: absolute;
    right: max(var(--container-min-margin), env(safe-area-inset-right));
}
